import { ProfileDropdown as ProfileDropdownComponent } from './ProfileDropdown';

export const ProfileDropdown = ProfileDropdownComponent;
